import moment from 'moment';
import {
	// total week shipment on dashboard
	TOTAL_WEEK_SHIPMENT_DATA,
	TOTAL_WEEK_SHIPMENT_LOADING,
	TOTAL_WEEK_SHIPMENT_ERROR,

	// Get Today Loading Bookings
	GET_LOADING_BOOKINGS_DATA,
	GET_LOADING_BOOKINGS_LOADING_DATA,
	GET_LOADING_BOOKINGS_ERROR,

	// total year shipment on dashboard
	TOTAL_YEAR_SHIPMENT_DATA,
	TOTAL_YEAR_SHIPMENT_LOADING,
	TOTAL_YEAR_SHIPMENT_ERROR,

	// Get Total Shipment Count based on Current Month
	GET_TOTAL_CURRENT_MONTH_SHIPMENT_DATA,
	GET_TOTAL_CURRENT_MONTH_SHIPMENT_LOADING,
	GET_TOTAL_CURRENT_MONTH_SHIPMENT_ERROR,

	//get Chart Data based on Bookings and Container
	GET_CHARTS_DATA,
	GET_CHART_DATA_LOADING,
	GET_CHART_DATA_ERROR,

	// Get Booking Chart Data Based On Supplier Location
	GET_BOOKING_CHART_DATA_BASED_ON_SUPPLIER_LOCATION_DATA,
	GET_BOOKING_CHART_DATA_BASED_ON_SUPPLIER_LOCATION_ERROR,
	GET_BOOKING_CHART_DATA_BASED_ON_SUPPLIER_LOCATION_LOADING,

	// Get Container Counts Based on Booking Status
	GET_CONTAINER_COUNTS_BASED_ON_BOOKING_STATUS_DATA,
	GET_CONTAINER_COUNTS_BASED_ON_BOOKING_STATUS_ERROR,
	GET_CONTAINER_COUNTS_BASED_ON_BOOKING_STATUS_LOADING,

	// Get Advanced Booking Count
	GET_ADVANCED_BOOKING_COUNT_DATA,
	GET_ADVANCED_BOOKING_COUNT_ERROR,
	GET_ADVANCED_BOOKING_COUNT_LOADING,
	SET_SELECTED_TASKS_SCHEDULE,
	GET_SELECTED_TASKS_SCHEDULE
} from './actionTypes';

const INIT_STATE = {
	chartsData: [],
	// Total week shipment on dashboard
	totalweeksShipmentLoading: false,
	totalweeksShipmentError: false,
	totalweekShipmentData: [],
	// Get Today Loading Bookings
	getLoadingBookingsLoading: false,
	getLoadingBookingData: [],
	getLoadingBookingError: false,

	// total year shipment on dashboard
	totalyearShipmentLoading: false,
	totalyearShipmentError: false,
	totalyearShipmentData: [],

	// Get Total Shipment Count based on Current Month
	totalCurrentMonthShipmentLoading: false,
	totalCurrentMonthShipmentError: false,
	totalCurrentMonthShipmentData: [],

	// Get Chart Data based on Bookings and Container
	getChartsDataLoading: false,
	getChartsDataError: false,
	getChartsData: [],

	// Get Booking Chart Data Based On Supplier Location
	getBookingChartBasedOnSupplierLocationLoading: false,
	getBookingChartBasedOnSupplierLocationError: false,
	getBookingChartBasedOnSupplierLocationData: [],

	// Get Container Counts Based on Booking Status
	getContainerCountsBasedOnBookingStatusLoading: false,
	getContainerCountsBasedOnBookingStatusError: false,
	getContainerCountsBasedOnBookingStatusData: [],

	// Get Advanced Booking Count
	getAdvancedBookingCountLoading: false,
	getAdvancedBookingCountError: false,
	getAdvancedBookingCountData: [],

	//TaskSchedule
	selectedTaskSchedule: { selectedDatesArrayValue: moment().format('Do'), activeTab: 1, selectedFullDate: moment() }
};

const Dashboard = (state = INIT_STATE, action) => {
	switch (action.type) {
		case TOTAL_WEEK_SHIPMENT_DATA:
			return {
				...state,
				totalweekShipmentData: action.payload,
				totalweeksShipmentLoading: false,
				totalweeksShipmentError: false
			};
		case TOTAL_WEEK_SHIPMENT_LOADING:
			return {
				...state,
				totalweeksShipmentLoading: true,
				totalweeksShipmentError: false,
				totalweekShipmentData: []
			};
		case TOTAL_WEEK_SHIPMENT_ERROR:
			return {
				...state,
				totalweeksShipmentLoading: false,
				totalweeksShipmentError: true,
				totalweekShipmentData: []
			};
		case GET_LOADING_BOOKINGS_DATA:
			return {
				...state,
				getLoadingBookingData: action.payload,
				getLoadingBookingsLoading: false,
				getLoadingBookingError: false
			};
		case GET_LOADING_BOOKINGS_LOADING_DATA:
			return {
				...state,
				getLoadingBookingsLoading: true,
				getLoadingBookingError: false,
				getLoadingBookingData: []
			};
		case GET_LOADING_BOOKINGS_ERROR:
			return {
				...state,
				getLoadingBookingsLoading: false,
				getLoadingBookingError: true,
				getLoadingBookingData: []
			};
		case TOTAL_YEAR_SHIPMENT_DATA:
			return {
				...state,
				totalyearShipmentData: action.payload,
				totalyearShipmentLoading: false,
				totalyearShipmentError: false
			};
		case TOTAL_YEAR_SHIPMENT_LOADING:
			return {
				...state,
				totalyearShipmentLoading: true,
				totalyearShipmentError: false,
				totalyearShipmentData: []
			};
		case TOTAL_YEAR_SHIPMENT_ERROR:
			return {
				...state,
				totalyearShipmentLoading: false,
				totalyearShipmentError: true,
				totalyearShipmentData: []
			};
		case GET_TOTAL_CURRENT_MONTH_SHIPMENT_DATA:
			return {
				...state,
				totalCurrentMonthShipmentData: action.payload,
				totalCurrentMonthShipmentLoading: false,
				totalCurrentMonthShipmentError: false
			};
		case GET_TOTAL_CURRENT_MONTH_SHIPMENT_LOADING:
			return {
				...state,
				totalCurrentMonthShipmentLoading: true,
				totalCurrentMonthShipmentError: false,
				totalCurrentMonthShipmentData: []
			};
		case GET_TOTAL_CURRENT_MONTH_SHIPMENT_ERROR:
			return {
				...state,
				totalCurrentMonthShipmentLoading: false,
				totalCurrentMonthShipmentError: true,
				totalCurrentMonthShipmentData: []
			};
		case GET_CHARTS_DATA:
			return {
				...state,
				getChartsData: action.payload,
				getChartsDataLoading: false,
				getChartsDataError: false
			};
		case GET_CHART_DATA_LOADING:
			return {
				...state,
				getChartsDataLoading: true,
				getChartsDataError: false,
				getChartsData: []
			};
		case GET_CHART_DATA_ERROR:
			return {
				...state,
				getChartsDataLoading: false,
				getChartsDataError: true,
				getChartsData: []
			};
		case GET_BOOKING_CHART_DATA_BASED_ON_SUPPLIER_LOCATION_DATA:
			return {
				...state,
				getBookingChartBasedOnSupplierLocationData: action.payload,
				getBookingChartBasedOnSupplierLocationLoading: false,
				getBookingChartBasedOnSupplierLocationError: false
			};
		case GET_BOOKING_CHART_DATA_BASED_ON_SUPPLIER_LOCATION_LOADING:
			return {
				...state,
				getBookingChartBasedOnSupplierLocationLoading: true,
				getBookingChartBasedOnSupplierLocationError: false,
				getBookingChartBasedOnSupplierLocationData: []
			};
		case GET_BOOKING_CHART_DATA_BASED_ON_SUPPLIER_LOCATION_ERROR:
			return {
				...state,
				getBookingChartBasedOnSupplierLocationLoading: false,
				getBookingChartBasedOnSupplierLocationError: true,
				getBookingChartBasedOnSupplierLocationData: []
			};
		case GET_CONTAINER_COUNTS_BASED_ON_BOOKING_STATUS_DATA:
			return {
				...state,
				getContainerCountsBasedOnBookingStatusData: action.payload,
				getContainerCountsBasedOnBookingStatusLoading: false,
				getContainerCountsBasedOnBookingStatusError: false
			};
		case GET_CONTAINER_COUNTS_BASED_ON_BOOKING_STATUS_LOADING:
			return {
				...state,
				getContainerCountsBasedOnBookingStatusLoading: true,
				getContainerCountsBasedOnBookingStatusError: false,
				getContainerCountsBasedOnBookingStatusData: []
			};
		case GET_CONTAINER_COUNTS_BASED_ON_BOOKING_STATUS_ERROR:
			return {
				...state,
				getContainerCountsBasedOnBookingStatusLoading: false,
				getContainerCountsBasedOnBookingStatusError: true,
				getContainerCountsBasedOnBookingStatusData: []
			};
		case GET_ADVANCED_BOOKING_COUNT_LOADING:
			return {
				...state,
				getAdvancedBookingCountLoading: true,
				getAdvancedBookingCountError: false,
				getAdvancedBookingCountData: []
			};
		case GET_ADVANCED_BOOKING_COUNT_ERROR:
			return {
				...state,
				getAdvancedBookingCountLoading: false,
				getAdvancedBookingCountError: true,
				getAdvancedBookingCountData: []
			};
		case GET_ADVANCED_BOOKING_COUNT_DATA:
			return {
				...state,
				getAdvancedBookingCountData: action.payload,
				getAdvancedBookingCountLoading: false,
				getAdvancedBookingCountError: false
			};

		case SET_SELECTED_TASKS_SCHEDULE:
			return {
				...state,
				selectedTaskSchedule: action.payload
			};
		case GET_SELECTED_TASKS_SCHEDULE:
			return {
				...state
			};
		default:
			return state;
	}
};

export default Dashboard;
